import React from 'react';
import { Global, css, type Theme } from '@emotion/react';

import { MOBILE_QUERY } from './layout';

const globalStyles = (theme: Theme) => css`
  /* цвета темы ui-kit - для чужого DOM (подсказка и кнопки MapLibre) */
  :root {
    --panel-bg: ${theme.color.surface.toString()};
    --text-strong: ${theme.color.textPrimary.toString()};
    --muted: ${theme.color.textSecondary.toString()};
    --border: ${theme.color.textSecondary.alpha(0.3).toString()};
    color-scheme: ${theme.isDark ? 'dark' : 'light'};
  }

  html,
  body,
  #root {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    font: 16px/1.4 system-ui, 'Segoe UI', Roboto, sans-serif;
    overflow: hidden;
    color: var(--text-strong);
    background: var(--panel-bg);
  }

  /* подсказка и кнопки карты MapLibre */
  .maplibregl-popup-content {
    background: var(--panel-bg);
    color: var(--text-strong);
  }

  .maplibregl-popup-close-button {
    color: var(--muted);
  }

  .maplibregl-popup-anchor-bottom .maplibregl-popup-tip,
  .maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip,
  .maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip {
    border-top-color: var(--panel-bg);
  }

  .maplibregl-popup-anchor-top .maplibregl-popup-tip,
  .maplibregl-popup-anchor-top-left .maplibregl-popup-tip,
  .maplibregl-popup-anchor-top-right .maplibregl-popup-tip {
    border-bottom-color: var(--panel-bg);
  }

  .maplibregl-popup-anchor-left .maplibregl-popup-tip {
    border-right-color: var(--panel-bg);
  }

  .maplibregl-popup-anchor-right .maplibregl-popup-tip {
    border-left-color: var(--panel-bg);
  }

  :root[data-theme='dark'] .maplibregl-ctrl-group {
    background: var(--panel-bg);
  }

  :root[data-theme='dark'] .maplibregl-ctrl-group button + button {
    border-top-color: var(--border);
  }

  :root[data-theme='dark'] .maplibregl-ctrl button .maplibregl-ctrl-icon {
    filter: invert(0.85);
  }

  :root[data-theme='dark'] .maplibregl-ctrl-attrib {
    background: rgba(30, 43, 51, 0.8);
    color: var(--muted);
  }

  :root[data-theme='dark'] .maplibregl-ctrl-attrib a {
    color: var(--muted);
  }

  * {
    box-sizing: border-box;
  }

  /* кнопка GeolocateControl - своя в MapControls, у контрола берём только поведение */
  .maplibregl-ctrl-geolocate,
  .maplibregl-ctrl-group:has(.maplibregl-ctrl-geolocate) {
    display: none !important;
  }

  .mobile-only {
    display: none !important;
  }

  /* панели поверх карты: на телефоне - на всю ширину */
  @media ${MOBILE_QUERY} {
    .mobile-only {
      display: revert !important;
    }

    .overlay-panel {
      top: 8px !important;
      left: 8px !important;
      right: 8px;
      width: auto !important;
      max-width: none !important;
    }

    .overlay-card {
      left: 8px !important;
      right: 8px;
      bottom: 8px !important;
      max-width: none !important;
      flex-wrap: wrap;
    }
  }
`;

const GlobalStyles: React.FC = () => <Global styles={globalStyles} />;

export default GlobalStyles;
